<div
  #container
  class="relative flex w-full flex-col overflow-hidden bg-cover"
  [ngStyle]="containerStyle | backgroundBucket"
  resizeObserver
  (resize)="resizeChart($event)"
  [caller]="'#sc3'"
>
  @if (content() && layout() && chart() && config().data) {
    @for (child of layout().children; track getChildrenId($index, child)) {
      <layout-container
        [child]="child"
        [config]="config()"
        [content]="content()"
        [options]="options"
        [context]="context()"
        [ngStyle]="child.style"
        (renderEvent)="layoutAction($event)"
      ></layout-container>
    }
  }

  @if (content()) {
    <tooltip2 [renderData]="config().data" [preFilterData]="config().preFilterData" [displayScale]="displayScale" [content]="content()"> </tooltip2>
  }

  @if (content() && !config().data) {
    <loading-indicator [@fadeAnimation] [icon]="'chart'" [circle]="true" [colors]="content().typeSpecific.style.colors2"></loading-indicator>
  }
</div>
